
(function () {
  'use strict';

  var config = window.SanoPrelaunchConfig || {};
  var root = config.root || '/';

  if (root.slice(-1) !== '/') root += '/';

  // Prelaunch uitgeschakeld: bestellen toegestaan.
  var enabled = false;

  function goToSignup() {
    if (window.SanoCart) window.SanoCart.close();

    var section = document.getElementById('sano-black-friday-signup');

    if (!section) {
      var url = new URL(root, location.origin);
      url.hash = 'sano-black-friday-signup';

      var params = new URLSearchParams(location.search);

      if (params.has('preview_theme_id')) {
        url.searchParams.set(
          'preview_theme_id',
          params.get('preview_theme_id')
        );
      }

      location.assign(url.href);
      return;
    }

    setTimeout(function () {
      var header = document.querySelector('header.header');
      var offset = header
        ? header.getBoundingClientRect().height
        : 0;

      window.scrollTo({
        top: Math.max(
          0,
          section.getBoundingClientRect().top +
            window.scrollY -
            offset -
            12
        ),
        behavior: matchMedia(
          '(prefers-reduced-motion:reduce)'
        ).matches ? 'auto' : 'smooth'
      });

      var phone = section.querySelector('input[type="tel"]');

      if (phone) {
        phone.focus({ preventScroll: true });
      }
    }, 100);
  }

  function checkoutMessage() {
    return '';
  }

  window.SanoPrelaunch = Object.freeze({
    enabled: enabled,
    goToSignup: goToSignup,
    checkoutMessage: checkoutMessage
  });

  // Geen blokkade van checkout-links, knoppen of formulieren.
  // Shopify verzorgt de normale afrekenprocedure.

})();
